export default function findOrganizationName(organizationId, courses) {
    const matchingCourse = courses.find(course => course.organization_id === organizationId);
    return matchingCourse.organization;
  }